<template>
  <div style="width: 100%;">
    <waterfall :col="col" :data="data">
      <template>
        <div class="cell-item" v-for="(item, index) in data" :key="index" @click="imgClick(item)">
<!--        <div class="cell-item" v-for="(item, index) in data" :key="index">-->
           <img :src="item.url" alt="加载错误" />
          <div class="item-body">
            <div class="item-desc">{{ item.content }}</div>
            <div class="item-footer">
              <div class="footer-left">
                <!-- <img :src="item.avatar" alt="" srcset="" /> -->
                <span class="time">{{item.shootTime}}</span>
                <div class="name">{{ item.shootPlace }} </div>
              </div>
              <div class="like">
                <div class="like-total">{{ item.shootUser }} 摄</div>
              </div>
            </div>
          </div>
        </div>

        <el-dialog fullscreen :visible.sync="dialogVisibleImg" width="100%"   style="z-index: 9999 !important;"  close-on-click-modal :modal="false" >

          <div  class="image-preview" style="height: 100%;">
            <div >
              <div @click="prevImage" style="position: fixed;left: 5%; top: 50vh;width: 40px;height: 40px; border-radius: 50%;background-color: rgba(0,0,0,0.2);">
                <i style="font-size: 18px;color: #fff;position:fixed;left: 5%; top: 50vh;cursor: pointer;margin-left: 9px;line-height: 40px" class="el-icon-arrow-left"></i>
              </div>
              <div style="" class="preview-image">
              <img  :src="currentImage" id="image"/>
                  <div class="preview-text" >
                    <div style="color: white">{{ currentContent }}</div>
                    <div style="color: white">{{ currentUser }} 摄</div>
                  </div>
                  <div class="preview-text-bottom" >
                    <span>{{ currentTime }}</span>
                    <span style="margin-left: 16px;">{{ currentPlace }}</span>
                  </div>
                <div style="position: fixed;margin-left: 50%;  transform: translate(-50%,0%); text-align: center;width: 350px;height: 40px;border-radius: 20px;background-color: rgba(255,255,255,.2);">
                  <span class="el-icon-plus"  style="margin: 0 20px;color: white;line-height: 40px" @click="zoomIn"></span>
                  <span class="el-icon-minus"  style="margin: 0 20px;color: white;line-height: 40px" @click="zoomOut"></span>
                  <span class="el-icon-full-screen"  style="margin: 0 20px;color: white;line-height: 40px" @click="fullScreenClick"></span>
                </div>
              </div>
              <div @click="nextImage" style="position: fixed;right: 5%; top: 50vh;width: 40px;height: 40px; border-radius: 50%;background-color: rgba(0,0,0,0.2);">
                <i style="font-size: 18px;color: #fff;position:fixed;right: 5%; top: 50vh;line-height: 40px;margin-right: 8px;cursor: pointer" class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="thumbnail-list">
              <img v-for="(img, index) in data" :key="index" :src="img.url" alt="" @click="imageClick2(img.url,index)" />
            </div>
          </div>
        </el-dialog>

      </template>
    </waterfall>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      col: 5,
      list: [],
      dialogVisibleImg: false,
      currentImage: null,
      isShowLittle: false,
      activeClass: '',
      showPreview: false, // 控制大图预览显示
      currentImageIndex: 0, // 当前预览图片的索引
      fullscreenMode: true, // 全屏模式
      currentContent: '',
      currentTime: '',
      currentPlace: '',
      currentUser: '',
      selectedImage: [],
      scale: 1,
      step:0.2

    };
  },
  mounted() {
    // console.log(this.data);
   this.list =  this.data.map(item => {
     // console.log(item.url)
      return item.url
    })
    this.selectedImage = this.data
    // console.log(this.data)
  },
  computed: {
    currentImage() {
      return this.selectedImage[this.currentImageIndex].url;
    }
  },
  methods: {
    /**
     * 放大
     */
    zoomIn() {
      this.scale += this.step;
      this.applyZoom();
    },
    /**
     * 缩小
     */
    zoomOut() {
      this.scale -= this.step;
      this.applyZoom();
  },

    applyZoom() {
    let image = document.getElementById('image');
    image.style.transform = 'scale(' + this.scale + ')';
  },
    /**
     * 全屏
     */
    fullScreenClick() {
      // 获取图片元素
      const image = document.getElementById('image');
// 进入全屏模式
      if (image.requestFullscreen) {
        image.requestFullscreen();
      } else if (image.mozRequestFullScreen) { // 兼容 Firefox
        image.mozRequestFullScreen();
      } else if (image.webkitRequestFullscreen) { // 兼容 Chrome, Safari 和 Opera
        image.webkitRequestFullscreen();
      } else if (image.msRequestFullscreen) { // 兼容 IE/Edge
        image.msRequestFullscreen();
      }
    },
    /**
     * 上一页
     */
    prevImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
      }else {
        this.currentImageIndex = this.selectedImage.length-1

      }
      this.currentImage = this.selectedImage[this.currentImageIndex].url;
      this.currentContent = this.selectedImage[this.currentImageIndex].content
      this.currentTime = this.selectedImage[this.currentImageIndex].shootTime
      this.currentPlace = this.selectedImage[this.currentImageIndex].shootPlace
      this.currentUser = this.selectedImage[this.currentImageIndex].shootUser




    },
    /**
     * 下一页
     */
    nextImage() {
      if (this.currentImageIndex < this.selectedImage.length - 1) {
        this.currentImageIndex++;
      }else {
        this.currentImageIndex = 0
      }
      this.currentImage = this.selectedImage[this.currentImageIndex].url;
      this.currentContent = this.selectedImage[this.currentImageIndex].content
      this.currentTime = this.selectedImage[this.currentImageIndex].shootTime
      this.currentPlace = this.selectedImage[this.currentImageIndex].shootPlace
      this.currentUser = this.selectedImage[this.currentImageIndex].shootUser
    },
    toggleFullscreen() {
      this.fullscreenMode = !this.fullscreenMode;
      // 在这里实现全屏效果的逻辑
    },
    imgClick(item) {
      // console.log(item, this.data)
      /**
       * 点击图片放大图片
       * @param player
       */
        this.currentImage = item
        this.dialogVisibleImg = true;
        this.currentImageIndex = this.selectedImage.findIndex((i) => i.id === item.id);
        this.currentImageIndex = this.selectedImage.findIndex((i) => {
          return  i.id === item.id
        })
        this.currentImage = this.selectedImage[this.currentImageIndex].url
        this.currentContent = this.selectedImage[this.currentImageIndex].content
      this.currentTime = this.selectedImage[this.currentImageIndex].shootTime
      this.currentPlace = this.selectedImage[this.currentImageIndex].shootPlace
      this.currentUser = this.selectedImage[this.currentImageIndex].shootUser
      },
    imageClick2(val,index) {
      // console.log('5675',index)
      this.currentImage = val
      this.currentImageIndex = index;
      this.currentContent = this.selectedImage[this.currentImageIndex].content
      this.currentTime = this.selectedImage[this.currentImageIndex].shootTime
      this.currentPlace = this.selectedImage[this.currentImageIndex].shootPlace
      this.currentUser = this.selectedImage[this.currentImageIndex].shootUser
      // console.log(this.currentImageIndex)
    },
  },
};
</script>
<style lang="scss" scoped>
.item-body {
  margin: 9px;
  //height: 100vh;
  .item-desc {
    text-align: left;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #000000;
  }
  .item-footer {
    display: flex;
    justify-content: space-between;
    .footer-left {
      display: flex;
      align-items: center;
      font-family: SF Pro Display;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;
      color: #333;
      margin: 16px 0;
      img {
        border-radius: 50%;
        width: 22px;
        height: 22px;
        margin-right: 4px;
      }
      .time {
        margin-right: 4px;
        font-size: 14px;
      }
      .name {
        font-size: 14px;
        color: #333;
      }
    }
    .like {
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: SF Pro Display;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;
      color: #333;
      img{
          margin-right: 4px;
      }
    }
  }
}
.cell-item {
  width: 100%;
  margin-bottom: 6px;
  background: #ffffff;
  border: 2px solid #f0f0f0;
  border-radius: 6px;
  overflow: hidden;
  box-sizing: border-box;
  &:after{
    content: "";
    display: block;
    clear: both;
  }
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.image-preview {
  position: absolute;
  text-align: center;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  .preview-image {
    position: fixed;
    top: 20px !important;
    margin-left: 50%;
    text-align: center;
    width: auto;
    height: 540px;
    transform: translate(-50%,0%);
    object-fit: contain;
    .preview-text{
      display: flex;
      justify-content: space-between;
      margin: 4px 16px;
      font-size: 16px
    }
    .preview-text-bottom {
      color: white;
      text-align: left;
      margin-left: 16px;
      font-size: 16px
    }
    img {
      width: 100%;
      height: 95%;
    }
  }
}
.image-preview img {
  width: 50%;
  //height: 50% * 3 / 4 !important;
  border-radius: 4px;
  border: 2px solid #fff;
  object-fit: cover;
}
.thumbnail-list {
  //width: 100vw;
  padding: 0 10px;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  text-align: left;
  position: absolute;
  bottom: 10vh;

}

.thumbnail-list img {
  width: 80px;
  height: 80px ;
  margin: 0 5px;
  transform: scale(1);
  transition: transform 3s ease 0s;

  &:hover {
    cursor: pointer;
    transform: scale(1.05);
  }
}
</style>

